
// ***********
// ** V: 1.3
// ***********



SLIDE_VERTICAL = 0;
SLIDE_HORIZONTAL = 1;

circleRotate = 0;
previousScroll = 0;
window.circleTransform = 'translate(-50%, -55%)';
previousTimeStamp = 0;
easeCount = 0;
easeScrolling = false;
pianoBlur = 40;
titleBlur = 5;
scrollPercentage = 0;

buySectionStick = false;
buySectionStickPos = 0;
menuUnderlayVisible = false;

submittedNewsletter = false;
addedToCart = false;


circleBlur = 0;
circleScale = 1;
circleRotate = 1;
videoCurrentTime = 0;


clipPaths = [0, 0, 0, 0, 0];
clipFixed = [false, false, false, false, false];
waterDisplay = "block";

function scrollToDefaultPos() {
    if(window.currentPage == window.PAGE_PIANO) {
    } else {
        $(window).scrollTop(0);
    }
}


// ***  MOBILE WORKAROUND
// CHECK IF COOKIE WRAPPER HAS LOADED
// IF SO, CHANGE THE WIDTH TO FIT THE PAGE
// ***
wrapperCheck = 0;
function checkWrapper() {
  cookieWrapper = document.getElementsByClassName('cookieconsent-wrapper');
    if(cookieWrapper.length>0) {
      cookieWrapper[0].setAttribute('style', 'width: auto !important');
    } else {
      if(wrapperCheck < 150) window.requestAnimationFrame(checkWrapper);
      wrapperCheck += 1;
    }
}


const classes = document.body.classList;
let timer = 0;

/* Cached GUI elements */

let instrumentCircleElement;
let videoElement;

$(document).ready(function(){
    detectCurrentPage();

    // FIX POSTER
  



     // window.setTimeout(renderSketch, 1000);
    window.setTimeout(function() {
      document.body.classList.add('loaded');
    }, 1000);

    checkWrapper();

    // PARSE PRICE
    if(window.currentPage == window.PAGE_PIANO) {
        parsePrice();
        // LOAD VIDEO POSTER
        document.getElementById('teaser-instrument').setAttribute('poster', isMobile ? 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster_mob.jpg' : 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster.jpg');
    } else if(window.currentPage == window.PAGE_MALLETS) {
        parsePrice();
        // LOAD VIDEO POSTER
       document.getElementById('teaser-instrument').setAttribute('poster', isMobile ? 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster_mallets_mob.jpg?v=1780139694' : 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/mallets_stills_11.jpg');
    } else if(window.currentPage == window.PAGE_TXT) {
        parsePrice();
        // LOAD VIDEO POSTER
        document.getElementById('teaser-instrument').setAttribute('poster', isMobile ? 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster_mob.jpg' : 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster.jpg');
    }
    
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
    else
        classes.add('stop-transitions');
        timer = setTimeout(() => {
        classes.remove('stop-transitions');
        timer = null;
    }, 100);

  
    $(document).on('keydown', function(event) {
        if (event.key == "Escape" && window.currentPageType == window.PAGE_TYPE_INSTRUMENTS) {
            stopInstrumentVideo();
        }
    });

    if(window.currentPage == window.PAGE_PIANO && window.innerWidth <= 736) {
        document.getElementById('main-title-mobile').innerHTML = 'HANDCRAFTED PIANO';
    } else if(window.currentPage == window.PAGE_MALLETS && window.innerWidth <= 736) {
        document.getElementById('main-title-mobile').innerHTML = 'HANDCRAFTED MALLETS';
    } else if(window.currentPage == window.PAGE_TXT && window.innerWidth <= 736) {
        document.getElementById('main-title-mobile').innerHTML = 'HANDCRAFTED TEXTURES';
    }



  
    refreshMenu();
    

    $(window).on('resize', function() {
       if(window.currentPage == window.PAGE_HOME && window.innerWidth > 736) {
            document.getElementById('circle-main').style.transform = "rotate(0deg) translate(-50%, -50%)";
            document.getElementById('circle-main').style.filter = "blur(1px)";
            document.getElementById('circle-main').style.height = "50%";
       }
       if (timer) {
           clearTimeout(timer);
           timer = null;
       }
       else
           classes.add('stop-transitions');
           timer = setTimeout(() => {
           classes.remove('stop-transitions');
           timer = null;
       }, 100);
       // $(window).scrollTop(0);
    });

       
});




function refreshAboutCircle() {
    circleRotateTarget = window.pos_y*window.pos_x/10000+(window.scrollTop/20);
    circleBlurTarget = Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/200;
    circleScaleTarget = 1+Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/4000;
    
    circleRotate = lerp(circleRotate, circleRotateTarget, lerpEaseSlow * 2);
    circleBlur = lerp(circleBlur, circleBlurTarget, lerpEaseSlow * 2);
    circleScale = lerp(circleScale, circleScaleTarget, lerpEaseSlow * 2);
    if(isNaN(circleRotate)) circleRotate = 0;
    if(isNaN(circleBlur)) circleBlur = 1;
    if(isNaN(circleScale)) circleScale = 1;
    document.getElementById('text-image-1').style.transform = "translateX(-50%) translateY(-50%) rotate("+(circleRotate)+"deg) scale("+circleScale+")";
    document.getElementById('text-image-1').style.filter = "blur("+(circleBlur)+"px)";
}




// t = time, b = beginning value, c = change in value, d = duration


function easeOut (t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
}
function li(a, b, n) {
    return (1 - n) * a + n * b;
}
const lerpEase = 0.07 * 1.2 * 0.2;

const lerpEaseSlow = 0.07 * 1.2 * 0.2;
function lerp(p1, p2, t) {
    return p1 + (p2 - p1) * t;
}